/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-common.validate',
    'pip-events',
    '@thd-olt-global/thd-customer'
],
function(
    $,
    Mustache,
    pip,
    pipValidate,
    pipEvents,
    thdCustomer
){
  var isEmailErrorMessageForOOSItemsEnabled;

  var MESSAGE_STATES = {
    failure: {
      type: 'error',
      alertClass: 'danger',
      title: 'An error has occurred.',
      message: 'Please resubmit your email address.',
      form: { enabled: true }
    },
    duplicate: {
      type: 'success',
      alertClass: 'success',
      title: 'Thank you!',
      message: 'You are already signed up to receive a notification if this product is back in stock.',
      form: { enabled: false }
    },
    success: {
      type: 'success',
      alertClass: 'success',
      title: 'Thank you!',
      message: 'We\'ll send you an email if this product is back in stock.',
      form: { enabled: false }
    },
    init: {
      type: '',
      alertClass: '',
      title: '',
      message: '',
      form: { enabled: true }
    }
  };

  var view = {
    templates: {
      trackif: $('#buybelt__trackif').html()
    },
    classes: {
      formInputError: 'form-input__error',
      trackIf: 'trackif',
      uiValidation: 'ui-validation'
    },
    selectors: {
      canonical: 'link[rel="canonical"]',
      trackIf: '#trackif.trackif',
      trackIfEmail: '#trackif_email',
      uiValidation: '.ui-validation',
      submitBtn: '#trackif_submit'
    },
    render: function() {
      if (MESSAGE_STATES.init && !MESSAGE_STATES.init.features) {
        MESSAGE_STATES.init.features = {
          emailErrorMessageForOOSItemsEnabled: isEmailErrorMessageForOOSItemsEnabled
        };
      }

      $(view.selectors.trackIf)
        .html(Mustache.render(view.templates.trackif, MESSAGE_STATES.init));
    },
    updateDOM: {
      trackIf: function(type) {
        if (!MESSAGE_STATES[type]) return;

        if (!MESSAGE_STATES[type].features) {
          MESSAGE_STATES[type].features = {
            emailErrorMessageForOOSItemsEnabled: isEmailErrorMessageForOOSItemsEnabled
          };
        }
  
        $(view.selectors.trackIf)
          .html(Mustache.render(view.templates.trackif, MESSAGE_STATES[type]))
          .promise()
          .then(function () {
            if (type === 'failure') {
              toggleErrorMessage(true, true);
            }
          });
      }
    },
    initDOMEventListeners: function () {
      if (isEmailErrorMessageForOOSItemsEnabled) {
        $(document).off(view.selectors.trackIfEmail)
          .on('blur', view.selectors.trackIfEmail, uiEmailValidation);
      }
      $(document).off(view.selectors.submitBtn)
        .on('click', view.selectors.submitBtn, emailValidation);
    }
  };

  var model = {
    makeEmailQuery: function (email) {
      if (!pip || !pip.features || !pip.features.trackif) {
        return;
      }
      var req = {
        type: 'POST',
        url: 'https://' + pip.features.trackif.hostName + '.trackif.com/tools/auto',
        crossdomain: true,
        data: {
          "email": email,
          "url": $(view.selectors.canonical).attr('href'),
          "preset": "out-of-stock"
        },
        dataType: 'json'
      };
  
      $.ajax(req)
        .done(function(data) {
          view.updateDOM.trackIf(data.status);
        })
        .fail(function() {
          view.updateDOM.trackIf('error');
        });
    }
  }

  function toggleErrorMessage(hasError, isAfterRender) {
    var $trackIfEmailInput = $(view.selectors.trackIfEmail);
    var $trackIfError = $(view.selectors.trackIf).find(view.selectors.uiValidation);

    if (hasError) {
      $trackIfEmailInput.addClass(view.classes.formInputError);
      if (!isAfterRender) {
        $trackIfError.show();
      }
    } else {
      $trackIfEmailInput.removeClass(view.classes.formInputError);
      if (!isAfterRender) {
        $trackIfError.hide();
      }
    }
  }

  function emailValidation(e) {
    e.preventDefault();
    var email = $(view.selectors.trackIfEmail).val();

    if (isEmailErrorMessageForOOSItemsEnabled) {
      toggleErrorMessage(!pipValidate.testEmail(email));
      if ($(view.selectors.trackIfEmail).hasClass(view.classes.formInputError)) {
        pipEvents.trackif.trackifSubmitted.trigger();
        return;
      }
  
      model.makeEmailQuery(email);
      pipEvents.trackif.trackifSubmitted.trigger();
    } else {
      if (!pipValidate.testEmail(email)) {
        view.updateDOM.trackIf('email_missing');
    } else {
        model.makeEmailQuery(email);
    }
      pipEvents.trackif.trackifSubmitted.trigger();
    }
  }

  function uiEmailValidation() {
    var email = $(view.selectors.trackIfEmail).val();

    toggleErrorMessage(!pipValidate.testEmail(email));
  }

  function preFillEmailForAuthUser() {
    var thdCustomerCookie = new thdCustomer.ConfigurableCustomer();
    var userEmail = thdCustomerCookie && thdCustomerCookie.email;
    if (userEmail) {
      $(view.selectors.trackIfEmail).attr('value', userEmail).text(userEmail);
    }
  }

  return {
    init: function init() {
      var trackifFeature = pip.features.trackif;

      isEmailErrorMessageForOOSItemsEnabled = pip.features.emailErrorMessageForOOSItemsEnabled;

      if (!isEmailErrorMessageForOOSItemsEnabled) {
        MESSAGE_STATES.email_missing = {
          type: 'error',
          alertClass: 'danger',
          title: 'Email format is invalid.',
          message: 'Please enter a valid email address.',
          form: { enabled: true }
        };
      }
      if (trackifFeature.isEnabled && trackifFeature.hostName) {
        view.initDOMEventListeners();
      }
      view.render();
      if (pip.features.emailOosAuthUserEnabled) {
        preFillEmailForAuthUser();
      }
    }
  };
});

}.call(window));